import React from 'react'
import PropTypes from 'prop-types'
import {Text, Flex} from '@chakra-ui/react'

/**
 * PDC Disclaimer Block
 * @param {string} message
 * @returns {JSX.Element}
 */
export const PDCDisclaimerBlock = ({message, textCenter = 'left', padding = 12}) => {
    return (
        <Flex
            justifyContent={textCenter}
            p={padding}
            backgroundColor={'lightBeige'}
            borderColor={'pink'}
            borderWidth={'1px'}
        >
            <Text
                variant={'bodyBase2'}
                dangerouslySetInnerHTML={{
                    __html: message
                }}
                textAlign={textCenter}
            />
        </Flex>
    )
}

PDCDisclaimerBlock.propTypes = {
    message: PropTypes.string,
    textCenter: PropTypes.string,
    padding: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.number])
}
